import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import { Header } from "./components";
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { RLogo } from "./assets/svgIcon/customIcon";
import PrivateRoute from "./contexts/privateRoute";
import {
  Cart,
  ChangePassword,
  Congratulations,
  FaqPage,
  ForgotPassword,
  InformationCapture,
  KycVerification,
  Login,
  NotFound,
  ProductDetailsPage,
  RentalSummary,
  Signup,
  TermsConditionsPage,
  VerifyIdentity,
  Shop,
  PasswordResetSuccess,
  PaymentPage,
  CompletePurchase,
  ExtendRental,
} from "./pages";
import ScannerPage from "./pages/product/scanner";
import { AuthProvider, useAuth } from "./contexts/authContext";
import {
  AUTH_CRED,
  checkCookieExpiration,
  initializeSessionTimeout,
  QUOTE_SESSION,
} from "./utils/auth-utils";
import { ToastContainer } from "react-toastify";
import Maintainance from "./pages/serverErrorPages/maintainancePage";
import TidioChat from "./components/TidioChat/TidioChat";

const Layout: React.FC = () => {
  const location = useLocation();
  const hideHeader = [
    "/login",
    "/signup",
    "/forgotpassword",
    "/404",
    "/resetpassword",
    "/scanner",
    "/kyc-verify",
    "/termsconditions",
  ];
  const shouldHideHeader = hideHeader.includes(location.pathname);
  const navigate = useNavigate(); // Initialize the useNavigate hook

  useEffect(() => {
    // Check expiration for a specific cookie
    checkCookieExpiration(QUOTE_SESSION, navigate);
    checkCookieExpiration(AUTH_CRED, navigate);
  }, [navigate]);

  // useEffect(() => {
  //   initializeSessionTimeout()
  // })

  return (
    <div className={!shouldHideHeader ? `layout` : ""}>
      {!shouldHideHeader && <RLogo className="r-logo" />}
      {!shouldHideHeader && <Header />}
      <Outlet />
    </div>
  );
};

const RentalSummaryRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { isLoggedIn } = useAuth();
  if (searchParams.get('order')) return <RentalSummary />;
  return isLoggedIn ? <RentalSummary /> : <Navigate to="/login" />;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<Header />} />
            <Route path="/product" element={<ProductDetailsPage />} />
            <Route path="/scanner" element={<ScannerPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/resetpassword" element={<ChangePassword />} />
            <Route path="/password-reset-success" element={<PasswordResetSuccess />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/extend-rental" element={<ExtendRental />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:slug" element={<Shop />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/termsconditions" element={<TermsConditionsPage />} />
            <Route path="/congratulations" element={<Congratulations />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/complete-purchase/:id?" element={<CompletePurchase />} />

            <Route path="/rental-summary" element={<RentalSummaryRoute />} />
            <Route element={<PrivateRoute />}>
              <Route path="/changepassword" element={<ChangePassword />} />
              <Route path="/verify-identity" element={<VerifyIdentity />} />
              <Route path="/kyc-verify" element={<KycVerification />} />
              <Route
                path="/information-capture"
                element={<InformationCapture />}
              />
            </Route>
            <Route path="*" element={<NotFound />} />
            <Route path="/not-found" element={<NotFound />} />
          </Route>
          {/* <Route path="*" element={<Maintainance />} /> */}
        </Routes>
        <TidioChat />
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </AuthProvider>
  );
};

export default App;
